import { useState, useEffect, memo, FC } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import classes from "./ErrorModal.module.scss";

const style = {
  box: {
    position: "absolute",

    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: {
      xs: 300, // 0px以上の幅で360pxを適用
      sm: 300, // 600px以上の幅で400pxを適用
    },
    //width: 300,
    // bgcolor: "background.paper",
    bgcolor: "#d8deef",
    border: "none",
    borderRadius: "10px",
    boxShadow: 24,
    padding: "10px",
    p: 4,
  },
  titleContents: {
    display: "flex",
  },
  iconImage: {
    color: "error.main",
    marginTop: 0.5,
  },
  title: {
    color: "error.main",
  },
  message: {
    marginTop: "20px",
    marginLeft: "20px",
    marginBottom: "20px",
  },
};
type Props = {
  title: string;
  message: string;
  setIsShow: (value: boolean) => void;
};
export const ErrorModal: FC<Props> = memo((props) => {
  // console.log("ErrorModal");
  const { title, message, setIsShow } = props;
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setIsShow(false);
    setOpen(false);
  };

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style.box} onClick={handleClose}>
          <div className={classes.titleContainer}>
            <div>
              <ErrorOutlineIcon sx={style.iconImage} />
            </div>
            <div>
              <Typography
                id="modal-modal-title"
                sx={style.title}
                variant="h6"
                component="h2"
              >
                {title}
              </Typography>
            </div>
          </div>
          <Typography id="modal-modal-description" sx={style.message}>
            {message}
          </Typography>
        </Box>
      </Modal>
    </div>
  );
});
